export default __webpack_public_path__ + "static/media/Confident-Smaller.691ff420.svg";